export default __webpack_public_path__ + "static/media/sea-shore.21aca7b2.png";